<template>
  <RouterLink
    :class="$style.base"
    :to="{ name: toRouteName }"
  >
    <BaseIcon
      name="plus"
      color="success"
    />
    <BaseText bold>{{ text }}</BaseText>
  </RouterLink>
</template>

<script
  lang="ts"
  setup
>
const props = defineProps<{
  toRouteName: string;
  text: string;
}>();
</script>

<style
  lang="scss"
  module
>
.base {
  cursor: pointer;
  border: 1px dashed var(--color-success);
  display: flex;
  padding: $spacing;
  border-radius: $radius;
  gap: $spacing * 0.5;
}
</style>
